import React from 'react';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash';
import { DescriptionListLabel, DescriptionListValue } from '@web/atoms';
import { BoldText } from './styles.js';

const CheckoutSummaryFreshDisplay = ({ recipes, numPacksCopy }) => {
  return (
    <>
      <DescriptionListLabel>{'Fresh Recipes'}</DescriptionListLabel>
      <DescriptionListValue>
        <BoldText>
          {recipes.fresh.map(recipe => capitalize(recipe)).join(', ')}
        </BoldText>
      </DescriptionListValue>
      <DescriptionListLabel>No. of packs</DescriptionListLabel>
      <DescriptionListValue>
        <BoldText>{numPacksCopy}</BoldText>
      </DescriptionListValue>
    </>
  );
};

CheckoutSummaryFreshDisplay.displayName = 'CheckoutSummaryFreshDisplay';
CheckoutSummaryFreshDisplay.propTypes = {
  recipes: PropTypes.object.isRequired,
  numPacksCopy: PropTypes.string.isRequired,
};

const CheckoutSummaryDryDisplay = ({ recipes, bagCount }) => {
  return (
    <>
      <DescriptionListLabel>{'Baked Recipes'}</DescriptionListLabel>
      <DescriptionListValue>
        <BoldText>
          {recipes.dry.map(recipe => capitalize(recipe)).join(', ')}
        </BoldText>
      </DescriptionListValue>

      <DescriptionListLabel>No. of bags:</DescriptionListLabel>
      <DescriptionListValue>
        <BoldText>
          {bagCount} {bagCount === 1 ? 'Bag' : 'Bags'}
        </BoldText>
      </DescriptionListValue>
    </>
  );
};

CheckoutSummaryDryDisplay.displayName = 'CheckoutSummaryDryDisplay';
CheckoutSummaryDryDisplay.propTypes = {
  recipes: PropTypes.object.isRequired,
  bagCount: PropTypes.number.isRequired,
};

export const CheckoutSummaryDisplayRecipes = ({
  productType,
  recipes,
  numPacksCopy,
  bagCount,
}) => {
  switch (productType) {
    case 'MX':
      return (
        <>
          <CheckoutSummaryFreshDisplay
            recipes={recipes}
            numPacksCopy={numPacksCopy}
          />
          <CheckoutSummaryDryDisplay recipes={recipes} bagCount={bagCount} />
        </>
      );
    case 'FR':
      return (
        <CheckoutSummaryFreshDisplay
          recipes={recipes}
          numPacksCopy={numPacksCopy}
        />
      );
    case 'DY':
      return (
        <CheckoutSummaryDryDisplay recipes={recipes} bagCount={bagCount} />
      );
    default:
      throw new Error('No ProductType');
  }
};

CheckoutSummaryDisplayRecipes.displayName = 'CheckoutSummaryDisplayRecipes';
CheckoutSummaryDisplayRecipes.propTypes = {
  productType: PropTypes.string.isRequired,
  recipes: PropTypes.object.isRequired,
  numPacksCopy: PropTypes.string.isRequired,
  bagCount: PropTypes.number.isRequired,
};
